module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama2.c3dc0491.jpeg";